<template>
    <div class="main">
<!-- 轮播图部分 -->
<el-carousel :interval="5000" arrow="always">
    <el-carousel-item v-for="item in swipelists" :key="item.imgurl">
      <img :src="item.imgurl" alt="">
    </el-carousel-item>
</el-carousel>
<!-- 功能介绍部分-->
       <div class="func_center columns">
         <div class="title rows">
            <img src="../assets/home/icon_lpng.png" alt="">
            <h3>功能介绍</h3>
            <img src="../assets/home/icon.png" alt="">
         </div>
         <div class="english rcenter">
           <p>Function introduction</p>
        </div>
         <div class="words row">
            <div class="word_item columns" v-for="(item,i) in funclists" :key="item.title" v-bind:class="picbounce==i?'box_shadow':''">
              
              <router-link to=""><img :src="item.imgurl" alt=""  @mouseover="pic(i)" :class="picbounce==i?'animated pulse':''" @mouseout="outpic(i)"></router-link>     
                             
               <div class="word_b">
                <h4>{{item.title}}</h4>
               <p>{{item.word}}</p>
               </div>               
            </div>
         </div>
       </div>

   <!-- 解决方案部分-->
         <transition name="solve">
                  <div class="solve" v-if="flag">
        <div class="solve_center column">
         <div class="title rows">
            <img src="../assets/home/icon_lpng.png" alt="">
            <h3>解决方案</h3>
            <img src="../assets/home/icon.png" alt="">
         </div>
         <div class="english rcenter">
           <p>Solve programme</p>
        </div>
        <div class="solve_box row">
        <div class="solve_item row" v-for="(item,i) in  solvelists" :key="item.imgurl" v-bind:class="shows==i?'animated pulse':''">
           <router-link :to="item.id" class="img_box">
                <img :src="item.imgurl" alt="" @mouseover="showit(i)" @mouseout="hideit(i)">
           </router-link>     
          <div class="solve_r column">
             <h5>{{item.title}}</h5>
             <div class="content">
                 {{item.word}}
             </div>

                <el-button size="mini" round type="primary" plain @click="gotolink(item.id)">详情</el-button>

             
          </div>
           
        </div>
        </div>
       
        <router-link to="/solution">
           <div class="more rows">
           <p @mouseover="changecolors" @mouseout="changegreys">更多解决方案</p>
           <transition name="arrow">
             <img :src="changes==true?arrow:blue" alt="" :class="changes==true?'':'arrow-enter'">
           </transition>
          
        </div>
        </router-link>
       
     
     </div>
      </div>      
         </transition>
   
   

       <!-- 客户案例部分-->
     
      <div class="cases_center column">
         <div class="title rows">
            <img src="../assets/home/icon_lpng.png" alt="">
            <h3>客户案例</h3>
            <img src="../assets/home/icon.png" alt="">
         </div>
         <div class="english rcenter">
           <p>Customer case</p>
        </div>
        <div class="case_box row animated">
          <div class="case_item column" v-for="(item,i) in caseslist" v-bind:class="picrotate==i?'box_shadow':''">
             <router-link :to="item.id">
               <img :src="item.imgurl" alt="" @mouseover="rotate(i)"  :class="picrotate==i?'animated pulse':''" @mouseout="hiderotate(i)">
             </router-link>
            

            <h5>{{item.title}}</h5>
            <div class="intro">{{item.word}}</div>
             <el-button size="mini" round type="primary" plain @click="gotolink(item.id)">详情</el-button>
          </div>
        </div>
        <router-link to="/cases">
              <div class="more rows">
             <p @mouseover="changecolor" @mouseout="changegrey">更多客户案例</p>
             <img :src="change==true?arrow1:blue1" alt="" :class="change==true?'':'arrow-enter'">
        </div>
        </router-link>
     
       </div>
       <!-- 底部栏 -->
       <div class="footer column">
         <div class="foot_box row">
           <div class="company column">
                <h5>北京奥腾岩石科技有限公司</h5>
                <div class="row">
                  <img src="../assets/home/address.png" alt="">
                  <p>北京经济技术开发区永昌南路8号A座</p>
                </div>
                <div class="row">
                  <img src="../assets/home/tel.png" alt="">
                  <p>010-58080000</p>
                </div>
                  <div class="row">
                  <img src="../assets/home/web.png" alt="">
                  <p>www.roctec.com.cn</p>
                </div>

           </div>
           <div class="group column">
                <h5>监测事业部</h5>
               <div class="row">
                  <img src="../assets/home/address.png" alt="">
                  <p>武汉市洪山区野芷湖西路16号武汉创意天地6号楼4层</p>
                </div>
                <div class="row">
                  <img src="../assets/home/tel.png" alt="">
                  <p>010-58080000</p>
                </div>
           </div>
           <div class="c_wx column">
             <h5>岩石科技微信</h5>
             <img src="../assets/home/company.png" alt="">
           </div>
           <div class="g_wx column">
              <h5>监测事业部微信</h5>
             <img src="../assets/home/wx.png" alt="">
           </div>
         </div>
         <div class="line"></div>
         <div class="footer_b rows">
           <div class="foot_l row">
             <p>版权所有© 2012-2016　北京奥腾岩石科技有限公司　京ICP备09067376号－2</p>
           </div>
           <div class="foot_r row">
             <p>联系我们 I 意见反馈</p>
           </div>
         </div>
       </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      swipelists: [
        {
          imgurl: require("../assets/home/h-1.jpg")
        },
        {
          imgurl: require("../assets/home/h-2.jpg")
        },
        {
          imgurl: require("../assets/home/h-3.jpg")
        },
        {
          imgurl: require("../assets/home/h-4.jpg")
        }
      ],
      funclists: [
        {
          imgurl: require("../assets/home/RocBox.png"),
          title: "高集成度自动化变形监测终端",
          word: "适用所有RS232/RS45智能传感器、GNSS接收机 以及测量机器人。"
        },
        {
          imgurl: require("../assets/home/RocMoS.png"),
          title: "专业化变形监测软件",
          word:
            "集成GNSS算法（动态与静态），智能传感器变形分析 测量平差以及精度评定多项专业功能模块。"
        },
        {
          imgurl: require("../assets/home/charts.png"),
          title: "人性化变形监测管理平台",
          word: "多样化数据展示、分析、管理以及预警"
        }
      ],
      solvelists: [
        {
          id: "/subway",
          imgurl: require("../assets/home/subway.jpg"),
          title: "地铁自动化监测",
          word:
            "地铁通常位于软弱破碎岩层，地质稳定性差。如果对地铁隧道变形控制不力，将会出现围岩迅速松弛，发生隧道冒顶坍方、地表 沉降、建筑物管线等变形..."
        },
        {
          id: "/tunnel",
          imgurl: require("../assets/home/h-6.jpg"),
          title: "隧道自动化监测",
          word:
            "隧道属于半隐蔽性工程,受运营年限、地质 条件、设计施工等因素的影响，经常出现隧道拱顶开裂边墙开裂、拱顶空洞、衬砌损坏 隧道渗漏水、隧道冻害..."
        },
        {
          id: "/dam",
          imgurl: require("../assets/home/h-7.jpg"),
          title: "大坝自动化监测",
          word:
            "大坝与人们生产生活息息相关，大坝安全问题越来越受到广泛的关注,其安全监测意义重大。因大坝的运行性态将随着运行时间的增 长而更趋复杂，为确保..."
        },
        {
          id: "/bridge",
          imgurl: require("../assets/home/h-8.jpg"),
          title: "桥梁自动化监测",
          word:
            "桥梁在交通、军事和社会生活等方面有着重要的战略意义，我国现有公路桥5000余座，总长130万公里，1/3以上的桥梁都存在 结构性缺陷、不同程度的损伤..."
        }
      ],
      caseslist: [
        {
          id: "/subulei",
          imgurl: require("../assets/home/su.jpg"),
          title: "苏布雷水电站GNSS监测系统",
          word:
            "苏布雷水电站GNSS监测系统是一套以数据采集、数据通讯为基础，自动进行数据分析、成果报告生成等全流程监测系统"
        },
        {
          id: "/subulei",
          imgurl: require("../assets/home/s1.jpg"),
          title: "苏布雷水电站GNSS监测系统",
          word:
            "苏布雷水电站GNSS监测系统是一套以数据采集、数据通讯为基础，自动进行数据分析、成果报告生成等全流程监测系统"
        }
      ],
      flag: false,
      picbounce: "",
      picrotate: "",
      shows: "",
      hides: "",
      arrow: require("../assets/home/right.png"),
      blue: require("../assets/home/blue_right.png"),
      arrow1: require("../assets/home/right.png"),
      blue1: require("../assets/home/blue_right.png"),
      change: true,
      changes: true
    };
  },
  //监听滚动条
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 解决方案模块滑动出现
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 500 && scrollTop < 600) {
        this.flag = !this.flag;
      } else {
        this.flag = true;
      }
    },
    // 鼠标滑过图片的动画
    pic(i) {
      this.picbounce = i;
    },
    outpic(i) {
      this.picbounce = -1;
    },
    showit(i) {
      this.shows = i;
    },
    hideit(i) {
      this.shows = -1;
    },
    rotate(i) {
      this.picrotate = i;
    },
    hiderotate(i) {
      this.picrotate = -1;
    },
    // 改变箭头颜色的方法
    changecolor() {
      this.change = !this.change;
    },
    changegrey() {
      this.change = true;
    },
    changecolors() {
      this.changes = !this.changes;
    },
    changegreys() {
      this.changes = true;
    },
    // 详情按钮点击跳转页面
    gotolink(id) {
      this.$router.replace(id);
    }
  }
};
</script>

<style>
/*过渡动画的css*/
.solve-enter,
.solve-leave-to {
  opacity: 0;
  transform: translateY(2rem);
}
.solve-enter-active,
.solve-leave-active {
  transition: all 1s ease;
}

.arrow-enter {
  opacity: 1;
  transform: translateX(0.2rem);
  transition: all 1s ease;
}

/*新增动画的类名*/
.box_shadow {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.05rem 0.11rem 0 rgba(223, 224, 233, 1);
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__container {
  width: 100%;
  height: 5.8rem;
}
.el-carousel__item img {
  width: 100%;
  height: 5.8rem;
}

a {
  text-decoration: none;
}

.func_center,
.solve_center,
.cases_center,
.foot_box {
  width: 12rem;
  height: 6.37rem;
  margin: 0 auto;
}
.func_center .title {
  margin-top: 0.01rem;
}
.title {
  margin-top: 0.8rem;
}
.func_center h3,
.solve_center h3,
.cases_center h3 {
  font-size: 0.34rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-left: 0.14rem;
  margin-right: 0.14rem;
}
.english {
  font-size: 0.12rem;
  font-family: ArialMT;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.english p {
  width: 1.93rem;
  height: 0.09rem;
  text-align: center;
}
.words {
  width: 100%;
  height: 3.4rem;
  margin-top: 0.25rem;
  justify-content: space-between;
}
.word_item {
  width: 30%;
  height: 4rem;
  text-overflow: ellipsis;
  overflow: hidden;
}
.word_item img {
  width: 100%;
  height: 2.5rem;
  margin-top: 0.35rem;
  cursor: pointer;
}
.word_b {
  width: 100%;
  height: 1.2rem;
}
.word_item h4 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 15px;
  margin-top: 0.05rem;
  margin-bottom: 0.1rem;
  text-align: center;
}
.word_item p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  text-align: center;
}
.solve {
  width: 100%;
  background: rgba(248, 249, 254, 1);
}
.solve_center {
  height: 9.6rem;
}
.solve_item {
  width: 5.7rem;
  height: 2.8rem;
  background: rgba(255, 255, 255, 1);
  margin-top: 0.4rem;
  text-overflow: ellipsis;
  box-shadow: 0 0.05rem 0.11rem 0 rgba(223, 224, 233, 1);
  cursor: pointer;
}
.solve_item img {
  width: 57%;
  height: 2.8rem;
  z-index: 99;
  cursor: pointer;
}
.solve_item h5 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  text-align: center;
  margin-top: 0.05rem;
  margin-bottom: 0.3rem;
}
.solve_item .content {
  height: 1.11rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 116, 1);
  text-overflow: ellipsis;
  margin-bottom: 0.3rem;
}
.solve_box {
  margin-top: 0.25rem;
  flex-wrap: wrap;
  justify-content: space-between;
  text-overflow: ellipsis;
}
.solve_r {
  padding: 0.24rem;
}
.el-button--mini,
.el-button--mini.is-round {
  width: 0.46rem;
  height: 0.26rem;
  text-align: center;
  padding: 7px 5px;
}
.more {
  margin-top: 0.77rem;
}
.more p {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  cursor: pointer;
}
.more p:hover {
  color: #1296db;
}
.case_item {
  width: 46%;
  height: 4.58rem;
  margin-top: 0.65rem;
  justify-content: flex-start;
  background: rgba(255, 255, 255, 1);
  text-overflow: ellipsis;
  overflow: hidden;
}
.case_item img {
  width: 100%;
  height: 2.8rem;
  cursor: pointer;
}
.case_item h5 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-left: 0.27rem;
  margin-bottom: 0.24rem;
}
.case_item .intro {
  width: 90%;
  height: 0.38rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 116, 1);
  padding-left: 0.27rem;
  text-overflow: ellipsis;
  margin-bottom: 0.2rem;
}
.case_item .el-button--mini {
  margin-left: 0.27rem;
}
.case_box {
  justify-content: space-between;
}
.cases_center {
  height: 8.5rem;
}

.footer {
  height: 3.06rem;
  background: rgba(61, 62, 73, 1);
}
.foot_box {
  height: 3.06rem;
}
.foot_box h5,
.footer_b h5 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 0.29rem;
  cursor: pointer;
}
.foot_box p,
.footer_b p {
  font-size: 0.12rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(178, 179, 185, 1);
  cursor: pointer;
}
.foot_box p:hover,
.foot_box h5:hover {
  color: #409eff;
}
.foot_box p {
  margin-bottom: 0.32rem;
  line-height: 0.24rem;
}
.company,
.group,
.c_wx,
.g_wx {
  margin-top: 0.5rem;
}
.company {
  width: 20%;
}
.group {
  width: 27%;
}
.company img,
.group img {
  width: 0.24rem;
  height: 0.24rem;
  margin-right: 0.1rem;
  cursor: pointer;
}

.c_wx img,
.g_wx img {
  width: 0.77rem;
  height: 0.77rem;
}
.line {
  width: 100%;
  height: 0.01rem;
  background: rgba(37, 43, 58, 1);
}
.footer_b {
  width: 12rem;
  height: 0.62rem;
  margin: 0 auto;
  justify-content: space-between;
}
.company {
  margin-right: 1.5rem;
}
.group {
  margin-right: 2rem;
}
.c_wx {
  margin-right: 0.45rem;
  width: 1.1rem;
}
.g_wx {
  width: 1.5rem;
}
.img_box {
  width: 15rem;
  height: 2.8rem;
}
.img_box img {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/homepages/main.vue